import { AsyncCallArgs, SimpleConfirmDialog, useAsyncCall } from "@duosoftbg/nacid-components";
import { toast } from "react-toastify";
import React from "react";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { closeModal } from "../../../../../store/redux/slice/ComponentsControl/groupsControl";
import { deleteGroup } from "../../../../../axios/api/services";

const GroupDeleteDialog = ({ filterFn }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.groupsControl.modals.delete;
  });

  const handleDeleteGroup = () => {
    const deleteGroupArgs: AsyncCallArgs = {
      promise: deleteGroup(id),
      onSuccess: () => {
        dispatch(closeModal({ modalType: "edit" }));
        dispatch(closeModal({ modalType: "delete" }));
        toast.success(t("m.group.delete.success"));
        filterFn();
      },
    };
    asyncCall(deleteGroupArgs);
  };

  const setModalOpen = (val) => {
    if (val === false) {
      dispatch(closeModal({ modalType: "delete" }));
    }
  };

  return (
    <SimpleConfirmDialog
      open={open}
      setOpen={setModalOpen}
      dialogTitleText={"m.confirm"}
      alertText={"m.group.delete.confirm"}
      alertType={"warning"}
      onConfirm={handleDeleteGroup}
    />
  );
};

export default GroupDeleteDialog;
